var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDragPerson = function SvgDragPerson(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 0.166626H2.66667C1.18667 0.166626 0 1.36663 0 2.83329V21.5C0 22.9666 1.18667 24.1666 2.66667 24.1666H8L12 28.1666L16 24.1666H21.3333C22.8 24.1666 24 22.9666 24 21.5V2.83329C24 1.36663 22.8 0.166626 21.3333 0.166626ZM12 4.56663C13.9867 4.56663 15.6 6.17996 15.6 8.16663C15.6 10.1533 13.9867 11.7666 12 11.7666C10.0133 11.7666 8.4 10.1533 8.4 8.16663C8.4 6.17996 10.0133 4.56663 12 4.56663ZM20 18.8333H4V17.6333C4 14.9666 9.33333 13.5 12 13.5C14.6667 13.5 20 14.9666 20 17.6333V18.8333Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDragPerson);
export { ForwardRef as ReactComponent };